import { render, staticRenderFns } from "./itensRelatorio.vue?vue&type=template&id=a10c7936&scoped=true&"
import script from "./itensRelatorio.vue?vue&type=script&lang=js&"
export * from "./itensRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./itensRelatorio.vue?vue&type=style&index=0&id=a10c7936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10c7936",
  null
  
)

export default component.exports